<template>
  <v-btn
    text
    @click="onClick"
    v-bind="$attrs"
    class="pl-2"
  >
    <v-icon left small>mdi-arrow-left</v-icon>
    <div class="text--secondary">{{ label || $t('general.back') }}</div>
  </v-btn>
</template>

<script>
import {RouterUtils} from '../utils/router-utils';

export default {
  name: 'BackButton',
  mixins: [
    RouterUtils,
  ],
  props: {
    label: {
      default () {
        return null;
      }
    },
    fallbackRoute: {
      default () {
        return 'Start';
      }
    },
    fallbackParams: {},
  },
  computed: {
    hasClickListener (){
      return this.$listeners && this.$listeners.click
    }
  },
  methods: {
    onClick () {
      if (this.hasClickListener) {
        this.$emit('click');
      } else {
        if(this.isFirstPage()) {
          this.pushToRoute(this.fallbackRoute, this.fallbackParams);
        } else {
          this.routerBack();
        }
      }
    }
  }
}
</script>
